import { useParams} from 'react-router-dom';
import { React, useEffect, useState } from 'react';

import CourseDetailsArea from '../components/common/curso/curso-detalhes';
import Cta from '../components/common/cta/cta';
import SEO from '../components/seo';
import Footer from '../layout/footers/footer';
import Header from '../layout/headers/header';
import Wrapper from '../layout/wrapper';
import { showCurso } from '../api/curso';
import { getPlanosCurso, checkCursoAtivo } from '../api/plano';
import { retrieveToken } from './../hooks/use-token';

const DynamicCourseDetails = () => {

  const { id } = useParams();
  const [courses, setCourses] = useState([]);
  const [course, setCourse] = useState(null);
  const [planos, setPlanos] = useState([]);
  const [activePayment, setActivePayment] = useState(false);

  useEffect(() => {

    if (course == null) {

      const tokenApi = retrieveToken();

      showCurso(tokenApi, id).then(function(result) {
        setCourse(result);
      });

      getPlanosCurso(tokenApi, id).then(function(result) {
        setPlanos(result);
      });

      checkCursoAtivo(tokenApi, id).then(function(result) {
        setActivePayment(result.payment);
      });

    }

});

  return (
    <Wrapper>
      {/* seo start */}
      <SEO pageTitle={'Detalhes do Curso'} />
      {/* seo end */}

      {/* header start */}
      <Header header_shadow={true} />
      {/* header end */}

      { course != null &&
      <CourseDetailsArea course={course} courses={courses} planos={planos} activePayment={activePayment} />
      }

      {/* cta start */}
      {/* <Cta /> */}
      {/* cta end */}

      {/* footer start */}
      <Footer />
      {/* footer end */}
    </Wrapper>
  );
};

export default DynamicCourseDetails;